import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsnavs',
	templateUrl:'./BSNavsPluginCompPage.html',
	styles: [],
	styleUrls:['./BSNavsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSNavsPluginCompPage
{
	mdContent_844 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.navs.BSNavs;
\`\`\``;
	mdContent_845 = `\`\`\`java
BSNavs()
\`\`\``;
	mdContent_846 = `\`\`\`java
BSNavs&lt;?&gt; navs = new BSNavs&lt;&gt;();
navs.setTabs(true);
navs.addTab("Home", homeContent);
navs.addTab("Profile", profileContent);
\`\`\``;
}
